export enum AppDataRequired {
    CONTACT = "contact",
    CONTACT_METADATA = "contact_metadata",
    AGENT = "agent",
    ASSIGNED_AGENT = "assignedAgent",
    CONVERSATION = "conversation",
    MESSAGES = "messages",
    TAGS = "tags",
    CHANNELS = "channels",
    CHANNELS_AUTH = "channels_auth",

    TEMPLATES = "templates",
}
